import config from '../config';

/**
 * Ottimizza l'URL dell'immagine utilizzando lo stile Drupal appropriato
 * @param {string} imageUrl - URL originale dell'immagine
 * @param {string} style - Stile Drupal da utilizzare (default: max_650x650)
 * @returns {string} - URL ottimizzato dell'immagine
 */
export const optimizeImageUrl = (imageUrl, style = 'max_650x650') => {
  if (!imageUrl) return null;

  const baseUrl = config.API_URL;
  const relativePathMatch = imageUrl.match(/\/sites\/default\/files\/(.+)/);

  if (relativePathMatch) {
    const relativePath = relativePathMatch[1];
    const isAlreadyWebp = relativePath.endsWith('.webp');
    const webpPath = isAlreadyWebp ? relativePath : `${relativePath}.webp`;
    
    // Costruisce path con lo stile specificato
    return `${baseUrl}/sites/default/files/styles/${style}/public/${webpPath}`;
  }

  return imageUrl; // Ritorna l'URL originale se non matcha il pattern
};

/**
 * Ottiene la prima immagine ottimizzata da un POI
 * @param {object} poi - Oggetto POI
 * @param {string} style - Stile Drupal da utilizzare
 * @param {string} fallback - URL di fallback se non ci sono immagini
 * @returns {string} - URL dell'immagine ottimizzata
 */
export const getOptimizedPoiImage = (poi, style = 'max_650x650', fallback = null) => {
  const imageUrl = poi?.field_immagini?.[0]?.url;
  
  if (imageUrl) {
    return optimizeImageUrl(imageUrl, style);
  }
  
  return fallback;
};

/**
 * Ottiene tutte le immagini ottimizzate da un POI
 * @param {object} poi - Oggetto POI
 * @param {string} style - Stile Drupal da utilizzare
 * @returns {Array} - Array di immagini ottimizzate
 */
export const getOptimizedPoiImages = (poi, style = 'max_650x650') => {
  if (!poi?.field_immagini?.length) return [];
  
  return poi.field_immagini.map(img => ({
    ...img,
    url: optimizeImageUrl(img.url, style)
  }));
};